import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../../pages/auth/auth.service';
import { RoleId } from '../../pages/auth/role';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const userRoleId = authService.getRoleId();
  const allowedRoles = route.data?.['allowedRoles'] as RoleId[] | undefined;

  const redirect = (path: string): UrlTree => router.createUrlTree([path]);

  if (!userRoleId) {
    return redirect('/auth');
  }

  if (allowedRoles?.length) {
    return allowedRoles.includes(userRoleId) ? true : redirect('/profilo/visualizza');
  }

  if ([RoleId.SA, RoleId.ADMIN].includes(userRoleId)) {
    return true;
  }

  return userRoleId === RoleId.AM ? redirect('/dashboard') : redirect('/profilo/visualizza');
};
